import "../../Styles/Classes/ClassesDetail.css";
import { NavLink, useParams } from "react-router-dom";
import { classesData } from "../../Assets/Data/ClassesData";
import ZGA from "../../Assets/ZGA.png";
import ClassesLevelDetails from "./ClassesLevelDetail";
import CalendarClock from "../../Assets/CalenderClock.png";
import Telegram from "../../Assets/Telegram.png";
import Meet from "../../Assets/Meet.png";
import { useContext } from "react";
import { ZGAContext } from "../../ZGAContext";

const ClassesDetail = () => {
  const { openModal, user } = useContext(ZGAContext);
  const { classId } = useParams();
  const selectedClass = classesData.find((cls) => cls.id === classId);

  return (
    <div className="classesDetail">
      {!selectedClass.levels && (
        <div className="LevellessClass">
          <div>
            <div>
              <span>
                <img src={ZGA} alt="The Zulaykha Global Academy" />
              </span>
              <div>
                <h1>{selectedClass.name}</h1>
                <p>
                  <img src={CalendarClock} alt="Calendar Clock" />
                  <span>
                    <span>{selectedClass.time[0]}</span>
                    <span>{selectedClass.time[1]}</span>
                  </span>
                </p>
                <span>
                  <span>Venue:</span>
                  <img src={Telegram} alt="Telegram" />
                  <img src={Meet} alt="Meet" />
                </span>
              </div>
              {selectedClass.classes && (
                <div>
                  <span>Classes</span>
                  <ul>
                    {selectedClass.classes.map((point, i) => (
                      <li key={i}>{point}</li>
                    ))}
                  </ul>
                </div>
              )}
              {selectedClass.subjects && (
                <div>
                  <span>Subjects</span>
                  <ul>
                    {selectedClass.subjects.map((point, i) => (
                      <li key={i}>{point}</li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
            <div>
              <img src={selectedClass.levellessImage} alt="Background" />
              <div className="gradient"></div>
            </div>
          </div>
          <div>
            <h3>Goals:</h3>
            <ul>
              {selectedClass.goals.map((point, i) => (
                <li key={i}>{point}</li>
              ))}
            </ul>
            <button onClick={() => openModal(user ? "rules" : "loginCheckpoint")}>{selectedClass.cButton}</button>
          </div>
          <div>
            <NavLink to="/">Home</NavLink>
          </div>
        </div>
      )}
      {selectedClass.levels && selectedClass.levels.length > 1 && <ClassesLevelDetails levels={selectedClass.levels} />}
    </div>
  );
};

export default ClassesDetail;
